import filter from "lodash/filter";
import { SidePanelType, useSidePanelsStore } from "PFApp/stores/side_panels_store";

export const useRoleDetailsPanelOpenAllocateManually = (): boolean =>
  useSidePanelsStore(
    (state) =>
      filter(state.panels, ({ key }) => key.startsWith(`${SidePanelType.BookingDetails}_role`)).pop()?.data
        .openAllocateManually
  );
